import { useEffect } from 'react';

import { useBalance } from '../../account/hooks/use-balance';
import type { IWallet } from '../../account/store/account.store';

export function useBalanceChange(callback: (wallets: IWallet[] | undefined) => void) {
    const { wallets } = useBalance();

    useEffect(() => {
        callback(wallets);
    }, [callback, wallets]);
}
